"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _FormElementWrapper = _interopRequireDefault(require("../FormElementWrapper"));

var _MenuRenderer = _interopRequireDefault(require("./MenuRenderer"));

require("rc-tree/assets/index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SelectTree = function SelectTree(props) {
  var input = props.input; // const [selectedOption, setSelectedOption] = useState(input.value);

  var styles = {
    clearIndicator: function clearIndicator() {
      return {};
    },
    menu: function menu() {
      return {};
    },
    menuList: function menuList() {
      return {};
    },
    container: function container() {
      return {};
    },
    control: function control() {
      return {};
    },
    option: function option() {
      return {};
    },
    singleValue: function singleValue() {
      return {};
    },
    placeholder: function placeholder() {
      return {};
    }
  };

  var onChange = function onChange(ops) {
    // Only for single value yet
    var selected = ops ? {
      label: ops.name,
      value: ops.id
    } : null; // setSelectedOption(selected);

    var input = props.input,
        isMulti = props.isMulti,
        hasExValue = props.hasExValue;

    if (input && input.onChange) {
      var result = selected;

      if (!hasExValue) {
        var valueKey = props.valueKey; // result = selected && (isMulti ? selected.map(option => option.value) : selected.value);
      }

      return input.onChange(result);
    }
  };

  var onClose = function onClose(data) {// debugger;
  };

  var onBlur = function onBlur(e) {
    return e.preventDefault();
  };

  var treeProps = _objectSpread(_objectSpread(_objectSpread({}, props), input), {}, {
    components: {
      MenuList: function MenuList(data) {
        return /*#__PURE__*/_react["default"].createElement(_MenuRenderer["default"], _extends({}, data, props, {
          value: input.value
        }));
      }
    }
  });

  return /*#__PURE__*/_react["default"].createElement(_FormElementWrapper["default"], props, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], _extends({}, treeProps, {
    styles: styles,
    value: input.value,
    onChange: onChange,
    onBlur: onBlur,
    onMenuOpen: onClose
  })));
};

SelectTree.displayName = 'SelectTree';
SelectTree.propTypes = {
  hasExValue: _propTypes["default"].bool,
  isAsync: _propTypes["default"].bool,
  isCreatable: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  hasOnWheel: _propTypes["default"].bool,
  options: _propTypes["default"].array,
  getNode: _propTypes["default"].func,
  labelKey: _propTypes["default"].string,
  valueKey: _propTypes["default"].string
};
SelectTree.defaultProps = {
  hasExValue: false,
  isAsync: false,
  isCreatable: false,
  label: '',
  required: false,
  hasOnWheel: true,
  options: [],
  getNode: null,
  labelKey: 'label',
  valueKey: 'value'
};
var _default = SelectTree;
exports["default"] = _default;